import type { ProjectInfo } from '../reduxStore/authReducer/authAction';

export interface FirestoreProjectTokenItem {
  token: string;
  development?: string;
  develpment?: string;
  production?: string;
}

export interface FirestoreProjectTokenMap {
  [project: string]: FirestoreProjectTokenItem;
}

export const normalizeProjectTokenItem = (
  project: string,
  item: FirestoreProjectTokenItem,
): ProjectInfo => {
  const testing = item.development || item.develpment;

  return {
    project,
    token: item.token,
    ...(item.production ? { production: item.production } : {}),
    ...(testing ? { testing } : {}),
    ...(testing ? { development: testing } : {}),
  };
};

export const normalizeProjectTokenMap = (
  tokenMap: FirestoreProjectTokenMap,
): ProjectInfo[] => Object.keys(tokenMap).reduce<ProjectInfo[]>((acc, project) => {
  const item = tokenMap[project];
  if (!item || !item.token) {
    return acc;
  }

  return acc.concat([normalizeProjectTokenItem(project, item)]);
}, []);
